import { Component } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { MasterService } from 'src/app/services/masters.service';
import { MenuItem } from '../../models/menu.model';

export class Base_pageComponent {
  pageInfo: MenuItem = new MenuItem();
  constructor(pageName: string,
    private _masterService: MasterService,
    private readonly _title: Title
  ) {
    this.getPageInfo(pageName)
  }

  getPageInfo(pageName: string) {
    this._masterService.getMenuDescription(pageName).subscribe(res => {
      this.pageInfo = res;
      this._title.setTitle(this.pageInfo.title || "National Distribution Monitor");
    })
  }
}
